import request from '@/utils/request'


// 查询门店教练列表
export function listShopShop(query) {
  return request({
    url: '/shop/shop/shop/list',
    method: 'get',
    params: query
  })
}

// 查询门店教练分页
export function pageShopShop(query) {
  return request({
    url: '/shop/shop/shop/page',
    method: 'get',
    params: query
  })
}

// 查询门店教练详细
export function getShopShop(data) {
  return request({
    url: '/shop/shop/shop/detail',
    method: 'get',
    params: data
  })
}

// 新增门店教练
export function addShopShop(data) {
  return request({
    url: '/shop/shop/shop/add',
    method: 'post',
    data: data
  })
}

// 修改门店教练
export function updateShopShop(data) {
  return request({
    url: '/shop/shop/shop/edit',
    method: 'post',
    data: data
  })
}

// 删除门店教练
export function delShopShop(data) {
  return request({
    url: '/shop/shop/shop/delete',
    method: 'post',
    data: data
  })
}

// 获取课程名称
export function courseName() {
  return request({
    url: '/shop/shop/shop/courseName',
    method: 'get',
  })
}
